import React, { useEffect } from 'react';
import style from './TreeMenus.scss';
import { SubMenuTitle } from '../SubMenuTitle';
import { TreeNavigationMenu } from './TreeNavigationMenu';
import { getName } from '../../../../utils/treeVisitors/helpers';
import { useTempRecords } from '../../../customHooks/react-use-temp-records';
import { sortNodesBySortOrderFirst } from '../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { useMenu } from '../../../customHooks/useMenu';
import { toUrlFormat } from '../../../../utils/treeVisitors';
import { CategoryLink } from '../CategoryLink';

export const TreeMenus = ({ menuSync, tree }) => {
  const { addRecord, hasRecords } = useTempRecords(500);
  const { toggleTreeNavigationMenu, shouldOpenTree } = useMenu();

  useEffect(() => {
    menuSync(`${window.location.pathname}${window.location.hash}`);
  }, []);

  return (
    <React.Fragment>
      {tree && Object.entries(tree).length > 0 && (
        <SubMenuTitle>API Reference</SubMenuTitle>
      )}
      {sortNodesBySortOrderFirst(tree).map((key, i) => {
        const currentTree = tree[key];
        if (currentTree.data) {
          return (
            <section
              key={key}
              className={style.treeMenuContainer}
              data-hook={`${toUrlFormat(
                getName(currentTree.data),
              )}-tree-menu-section`}
              data-section={`tree-menu-section-${i}`}
            >
              <CategoryLink
                isExpanded={shouldOpenTree(key)}
                title={getName(currentTree.data)}
                link={currentTree.data.urlFormat}
                onLinkClick={() => {
                  toggleTreeNavigationMenu(key);
                }}
                onExpandButtonClick={() => {
                  toggleTreeNavigationMenu(key);
                }}
                type="tree"
              />
              {shouldOpenTree(key) && (
                <TreeNavigationMenu
                  hasBeenClickedRecently={hasRecords}
                  markAsRecentlyClicked={addRecord}
                  key={key}
                  treeKey={key}
                  tree={currentTree}
                  treeDepth={0}
                  prefix={currentTree.data.urlFormat}
                  menuSync={menuSync}
                />
              )}
            </section>
          );
        }
        return null;
      })}
    </React.Fragment>
  );
};
